import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Home from "./menu/Home";
import _ from "i18n";
import { Header } from "tamtam-components";
import {
  TTP_PAYMENT_URL,
  TTP_HOME_URL,
  TTP_EMAILING_URL,
  LARAVEL_SESSION_COOKIE,
  AUTH_LOW_SECURITY_COOKIE_NAME,
  APP_ENV,
  TTP_AMAZON_S3,
  S3_STATS_FOLDER_URL,
} from "Config";
import { bindActionCreators } from "redux";
import { setAuth, setLanguage } from "actions";
import { uniqBy } from "lodash";
import { setCookie } from "utils";

const StatsUrl = TTP_PAYMENT_URL.slice(0, -1);
const homeUrl = TTP_HOME_URL.slice(0, -1);
const emailingUrl = TTP_EMAILING_URL.slice(0, -1);

const App = {
  appName: "Stats",
  appLogoUrl: `${S3_STATS_FOLDER_URL}/stats.png`,
  appUrl: StatsUrl,
  homeUrl: homeUrl
};

const rightIcons = {
  ebox: {
    activated: true,
    icon: "Ebox",
    url: `${emailingUrl}/e_box`
  },
  notifs: {
    activated: true,
    icon: "Notifs"
  },
  apps: {
    activated: true
  },
  backoffice: {
    activated: false
  },
  home: {
    activated: false
  },
  profile: {
    activated: true,
    url: `${homeUrl}/landing`
  },
  faq: {
    activated: true,
    icon: "Help"
  },
  search: {
    activated: false
  }
};

const Menu = ({ auth, lng, setLanguage, setAuth }) => {

  const [settings, setSettings] = useState([]);
  const prevAuth = useRef(auth);

  const changeLng = (newLng) => {
    if (lng === newLng) {
      return false;
    }
    setLanguage(newLng);
    window.location.reload();
    return null;
  };

  const logout = (e) => {
    e.preventDefault();
    setAuth(null);

    const dtExpire = new Date();
    const cookieName = `ttp_auth${APP_ENV != "" ? "_" : ""}${APP_ENV}`;
    const preferencesCookieName = `ttp_preferences${APP_ENV != '' ? '_' : ''}${APP_ENV}`;

      dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);

    setCookie(cookieName, "", dtExpire, "/", "tamtam.pro");
    setCookie(AUTH_LOW_SECURITY_COOKIE_NAME, "", dtExpire, "/", "tamtam.pro");
    setCookie("XSRF-TOKEN", "", dtExpire, "/", "tamtam.pro");
    setCookie(LARAVEL_SESSION_COOKIE, "", dtExpire, "/", "tamtam.pro");
    setCookie(`ttp_community_${APP_ENV}`, "", dtExpire, "/", "tamtam.pro");
    setCookie('laravel_session', '', dtExpire, '/', 'tamtam.pro');
    setCookie(preferencesCookieName, '', dtExpire, '/', 'tamtam.pro');
    setCookie(`ttp_session_${APP_ENV}`, '', dtExpire, '/', 'tamtam.pro');

    window.location = "/";
  };

  const handleSettingsByUserType = () => {
    let newSettings = [];
    const { loggedAs, user, loggedAsPost } = auth;
    const showStats =
      (loggedAs && loggedAs === "ADMIN") || (user && user.type == "ADMIN");

    if (showStats && APP_ENV !== "production" && APP_ENV !== "v2") {
      newSettings.push({
        label: _("Import Coda Testing"),
        url: "/importCodaTesting"
      });
    }

    setSettings(newSettings);
  };

  // componentDidMount
  useEffect(() => {
    handleSettingsByUserType();
  }, []);

  // componentDidUpdate
  useEffect(() => {
    if (auth !== prevAuth.current && auth != null) {
      handleSettingsByUserType();
    }
    prevAuth.current = auth;
  }, [auth]);

  const { loggedAs, user, currentClient, token } = auth;

  return (
    <header style={{ position: 'relative', zIndex: 99999 }}>
      {!user || !user.id ? (
        <div className="ttp_header_padding_fix">
          <Header
            env={APP_ENV}
            app={App}
            auth={{ navCommunity: null, user: null, token: null }}
            lng={lng}
            onLanguageChange={langue => changeLng(langue)}
          />
        </div>
      ) : (
        <div className="ttp_header_avatar_fix">
          <Header
            env={APP_ENV}
            app={App}
            auth={{
              navCommunity: currentClient,
              user: {
                ...user,
                communities: uniqBy(user.paymentClients, "id"),
                type: loggedAs
              },
              token
            }}
            lng={lng}
            settings={settings}
            rightIcons={rightIcons}
            onLanguageChange={langue => changeLng(langue)}
            onLogoutClick={e => logout(e)}
          />
        </div>
      )}
    </header>
  );
};

const mapStateToProps = store => ({
  auth: store.auth,
  lng: store.params.lng
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setLanguage,
      setAuth
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./app/components/Menu.js